import React from 'react';
import Dialog from 'components/modals/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import { getLetterInAlphabet } from 'utils/misc';
import Button from '../../../src/components/buttons/Button';


const PitchAddModal = (props) => {
  const {
    onCancelClick,
    onAcceptClick,
    onRejectClick,
    open,
    pitchIndex,
  } = props;
  return (
    <Dialog
      open={open}
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        {'Add Variant (A/B test)'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {pitchIndex > 0 &&
          `Do you want to fill variant 
           ${getLetterInAlphabet(pitchIndex).toUpperCase()}
           with variant ${getLetterInAlphabet(pitchIndex - 1).toUpperCase()}'s content?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div style={{ flex: '1 0 0' }}>
          <Button color="secondary" onClick={onCancelClick}>Cancel</Button>
        </div>
        <Button color="secondary" onClick={onRejectClick}>
          {"Don't Copy"}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onAcceptClick}
          autoFocus
        >
          Yes, Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PitchAddModal.propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  onAcceptClick: PropTypes.func.isRequired,
  onRejectClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pitchIndex: PropTypes.number.isRequired,
};

export default PitchAddModal;

